import { get } from "./request";
import { getFilePreviewUrl } from "./attachmentPreview";
import { downloadAttachmentAs } from "./downloadFile";

/**
 * 获取最新 App 版本信息与下载地址（用于说明弹窗、二维码）
 * @returns {Promise<{
 *   attachmentUuid: string,
 *   previewUrl: string,
 *   versionName: string,
 *   versionCode: string,
 *   description: string,
 * }>}
 */
export async function getLatestAppDownloadInfo() {
  const res = await get("/user/appVersion/getLastVersion");
  const versionData = res?.data ?? {};
  const attachmentUuid =
    versionData?.attachmentUuid ?? versionData?.attachmentUUID ?? "";

  if (!attachmentUuid) {
    return {
      attachmentUuid: "",
      previewUrl: "",
      versionName: "",
      versionCode: "",
      description: "",
    };
  }

  const previewUrl = await getFilePreviewUrl(attachmentUuid);

  return {
    attachmentUuid,
    previewUrl,
    versionName:
      versionData?.versionName ??
      versionData?.version ??
      versionData?.appVersion ??
      "",
    versionCode:
      versionData?.versionCode != null ? String(versionData.versionCode) : "",
    description:
      versionData?.description ??
      versionData?.remark ??
      versionData?.introText ??
      versionData?.updateContent ??
      "",
  };
}

/**
 * 下载最新 App APK
 * @param {Object} [options]
 * @param {(phase: 'preparing' | 'downloading') => void} [options.onPhase]
 * @param {(payload: { loaded: number, total: number, percent: number | null }) => void} [options.onProgress]
 * @returns {Promise<'ok' | 'no-version' | 'no-url' | 'fallback'>}
 */
export async function downloadLatestAppApk({ onPhase, onProgress } = {}) {
  onPhase?.("preparing");

  const info = await getLatestAppDownloadInfo();
  if (!info.attachmentUuid) {
    return "no-version";
  }

  onPhase?.("downloading");
  const result = await downloadAttachmentAs(info.attachmentUuid, {
    onProgress,
  });
  if (result === "no-url") return "no-url";
  return result === "fallback" ? "fallback" : "ok";
}
